<template>
  <div class="definition-actions">
    <action-button
      v-if="showSendDownStream"
      dark
      :disabled="!isSendDownStreamEnabled"
      @click.native="submitToDC"
      color="primary"
      label="send downstream"
    />
    <action-button
      v-if="showGenerateEstimate"
      dark
      @click.native="generateEstimate"
      color="primary"
      :label="activateLabel"
    />
    <action-button
      v-if="showDuplicate"
      dark
      color="secondary"
      @click.native="duplicate"
      label="Duplicate"
    />
    <action-button
      @click.native="downloadTargetPackage"
      dark
      color="secondary"
      v-if="allowDownloadBtn"
      label="download"
    />
    <action-button
      :disabled="canNotUndo"
      @click.native="undo"
      color="secondary"
      dark
      label="undo"
    />
    <action-button
      :disabled="canNotRedo"
      @click.native="redo"
      color="secondary"
      dark
      label="redo"
    />
    <action-button
      :disabled="isClearAllDisabled"
      @click.native="clear"
      color="secondary"
      dark
      label="Clear All"
    />
    <action-button
      :disabled="!isSaveEnabled"
      @click.native="save"
      color="success"
      :label="saveLabel"
      dark
      style="min-width: 100px"
    />
  </div>
</template>

<script>
  import ActionButton from '@/components/common/actionButton'
  // TODO: create a wrapper to handle getting the chart data for download
  // import LasAdDownloadBtn from './LasAdDownloadBtn'
  import {
    CLEAR_DEFINITION,
    UNDO_TARGET_DEF,
    REDO_TARGET_DEF,
  } from '@/appComponents/oldWorkbench/targetDefinition/store/actions'
  import { SAVE_TARGET, SUBMIT_TO_DC } from '@/views/workbenchCanvas/store/WorkbenchWCanvasSlotActionsGenerator'
  import { targetRouteHandler } from '@/helpers'
  import { DOWNLOAD_TARGET_DEFINITION } from '@/appLogic/targets/currentTarget/store/actions'
  import {
    TARGET_TYPE,
    TARGET_TYPES_INTEGERS,
    ACTIVATION_STATUS,
    INTENTS,
  } from '@/appLogic/targets/Constants'
  import { isEmpty } from 'lodash'

  export default {
    props: {
      allowDownloadBtn: {
        type: Boolean,
      },
    },
    components: {
      ActionButton,
      // LasAdDownloadBtn
    },
    computed: {
      activateLabel() {
        return this.currentTarget.target === TARGET_TYPE.SD ? 'Activate' : 'Generate Estimates'
      },
      isEpsilonTargetAndHasEpsilonPermissions() {
        const C360Datasources = this.$store.getters.getC360Datasources
        return this.currentTarget.target_datasource === C360Datasources.EPSILON
      },
      isLASTargetAndHasLASPermissions() {
        return this.$store.getters.hasCreateEditPermissions && this.currentTarget.target === TARGET_TYPE.LAS
      },
      isADTargetAndHasADPermissions() {
        return this.currentTarget.target_type === TARGET_TYPES_INTEGERS.AD
      },
      currentTargetHasChanged() {
        return this.$store.getters.currentTargetHasChanged
      },
      isSaveEnabled() {
        let hasPermissions =
          this.isEpsilonTargetAndHasEpsilonPermissions ||
          this.isLASTargetAndHasLASPermissions ||
          this.isADTargetAndHasADPermissions
        let canMakeASave =
          (this.$store.getters.targetDefinitionHasChanged || this.currentTargetHasChanged) &&
          this.$store.getters.isSaveEnabled
        console.log({ hasPermissions, canMakeASave })
        console.log({
          targetHasChanged: this.$store.getters.targetDefinitionHasChanged,
          isSavedEnabled: this.$store.getters.isSaveEnabled,
        })
        return hasPermissions && (canMakeASave || this.isDraft) && !this.$store.getters.loading
      },
      isSendDownStreamEnabled() {
        return (
          this.isEpsilonTargetAndHasEpsilonPermissions ||
          this.isLASTargetAndHasLASPermissions ||
          (this.isADTargetAndHasADPermissions &&
            !this.isTargetSubmitted &&
            this.currentTarget &&
            !isEmpty(this.currentTarget.target_definition) &&
            this.currentTarget.target_definition.query &&
            this.currentTarget.target_definition.query.length)
        )
      },
      isClearAllDisabled() {
        return !this.$store.getters.hasDefinition || this.$store.state.viewOnly || this.$store.getters.isTargetSubmitted
      },
      fetchingTarget() {
        return this.$store.getters.isFetchingTarget
      },
      loading() {
        return this.$store.getters.loading
      },
      saveLabel() {
        return this.$store.getters.isSaving ? 'Saving' : this.isSaveEnabled ? 'Save' : 'Saved'
      },
      canNotUndo() {
        return this.$store.getters.canNotUndo
      },
      canNotRedo() {
        return this.$store.getters.canNotRedo
      },
      currentTarget() {
        return this.$store.getters.currentTarget
      },
      showGenerateEstimate() {
        return this.$store.getters.showGenerateEstimate && this.hasCreateEditPermissions
      },
      showDuplicate() {
        return this.hasCreateEditPermissions
      },
      showSendDownStream() {
        return this.$store.getters.currentTarget.target === TARGET_TYPE.AD && !this.hasResearchIntent
      },
      hasResearchIntent() {
        return (
          this.currentTarget &&
          this.currentTarget.metadata &&
          (this.currentTarget.metadata.intents || []).some(el => el.IntentId === INTENTS.Research.IntentId)
        )
      },
      hasCreateEditPermissions() {
        return this.$store.getters.hasCreateEditPermissions
      },
      isDraft() {
        return this.currentTarget.activation_status === ACTIVATION_STATUS.DRAFT
      },
      isTargetSubmitted() {
        return this.$store.getters.isTargetSubmitted
      },
    },
    methods: {
      clear() {
        this.$store.dispatch(CLEAR_DEFINITION)
      },
      generateEstimate() {
        targetRouteHandler('ACTIVATE', this.currentTarget)
      },
      duplicate() {
        targetRouteHandler('DUPLICATE', this.currentTarget)
      },
      save() {
        this.$store.dispatch(SAVE_TARGET)
      },
      undo() {
        // these actions should call the target definition actions...
        this.$store.dispatch(UNDO_TARGET_DEF)
      },
      redo() {
        this.$store.dispatch(REDO_TARGET_DEF)
      },
      downloadTargetPackage() {
        this.$store.dispatch(DOWNLOAD_TARGET_DEFINITION, {
          targetId: this.currentTarget.id,
          targetDefinition: this.$store.getters.targetDefinition,
          audienceSize: this.$store.getters.audienceSize,
        })
      },
      submitToDC() {
        this.$store.dispatch(SUBMIT_TO_DC)
      },
    },
  }
</script>

<style lang="scss">
  .definition-actions {
    &__save-btn,
    &__clear-btn {
      min-width: rem(140);
    }
  }
</style>



// WEBPACK FOOTER //
// DefinitionActions.vue?66582a12